import React from 'react'
import Footer from '../Footer/Footer'
import Nav from '../Nav/Nav'
import useStore from '../../../Store'
import Services1 from './Services1'
import ServiceCards from './ServiceCards'

const ServicePage = () => {
    const direction = useStore((state) => state.direction);
    return (
        <div style={{ direction }}>
            <Nav />
            <div className={ServicePage.about_container}>
                <Services1/>
                <ServiceCards/>
            </div>
            <Footer />
        </div>
    )
}

export default ServicePage